<template>
    <div class="agri-platform-container">
        <div class="top-title">
            <h2>智能灌溉模型决策系统</h2>
        </div>
        <!-- 主体内容区域 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="11">
                <img :src="dashboardImg" alt="数字农业智能驾驶舱" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="13">
                <div class="desc-card">
                    <p>我公司为客户定制的智能灌溉模型决策系统，通过物联网传感器实时采集土壤墒情、作物生长状态和环境气象数据，结合智能算法自动生成最优灌溉方案。系统支持多区域墒情对比分析，可远程精准控制灌溉设备运行，实现水肥精准调控。
                    </p>
                    <p> 基于大数据分析，系统能够自动优化灌溉模型，智能调整灌溉策略。通过历史数据追溯和实时监控功能，帮助用户显著提高水资源利用率，降低生产成本，同时提升作物产量和品质。该系统特别适用于规模化种植园区，是实现精准农业的理想解决方案
                    </p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'AgriPlatformPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/Mainsoftware/znggmx.png')

        }
    }
}
</script>